"use strict";

module.exports = {
  stage2Path: function stage2Path(scope, mode) {
    if ((process.env.NODE_ENV === "development" || process.env.NODE_ENV === "testing") && mode !== "production") {
      return "//staging.demoup.com/" + scope + "/playbuttonRenderer.js";
      //return "//staging.demoup.com/" + scope + "/playbuttonRenderer.js";
    } else if (mode === "local") {
      return "//localhost:8080/" + scope + "/playbuttonRenderer.min.js";
    } else {
      return "//static.demoup.com/" + scope + "/playbuttonRenderer.min.js";
    }
  },
  containerPath: function containerPath(scope, mode) {
    if ((process.env.NODE_ENV === "development" || process.env.NODE_ENV === "testing") && mode !== "production") {
      return "//staging.demoup.com/" + scope + "/playbuttonContainer.js";
    } else if (process.env.NODE_ENV === "local") {
      return "//localhost:8080/" + scope + "/playbuttonContainer.min.js";
    } else {
      return "//static.demoup.com/" + scope + "/playbuttonContainer.min.js";
    }
  },
  stage3Path: function stage3Path(scope) {
    if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "testing") {
      return "//staging.demoup.com/" + scope + "/stage3.js";
    } else {
      return "//static.demoup.com/" + scope + "/stage3.min.js";
    }
  },
  playerRenderer: function playerRenderer(scope) {
    if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "testing") {
      return "//staging.demoup.com/" + scope + "/playerRenderer.js";
    } else {
      return "//static.demoup.com/" + scope + "/playerRenderer.min.js";
    }
  }
};